import React from 'react';

const tags = [
  'div',
  'span',
  'p',
  'section',
  'header',
  'footer',
  'article',
  'nav',
  'main',
  'aside',
  'ul',
  'ol',
  'li',
  'a',
  'button',
  'input',
  'textarea',
  'form',
  'label',
  'table',
  'thead',
  'tbody',
  'tr',
  'td',
  'th',
  'img',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
];

const tw = new Proxy(
  Object.fromEntries(tags.map((tag) => [tag, (target: any) => target])),
  {
    get(_, tag: string) {
      if (tags.includes(tag)) {
        return (strings: TemplateStringsArray, ...values: string[]) => {
          const templateClassName = strings.reduce(
            (acc: string, str: string, i: number) =>
              acc + str + (values[i] || ''),
            '',
          );
          return (props: React.HTMLAttributes<HTMLElement>) => {
            const { className: customClassName, ...restProps } = props;
            const combinedClassName = customClassName
              ? `${templateClassName} ${customClassName}`
              : templateClassName;
            return React.createElement(tag, {
              ...restProps,
              className: combinedClassName,
            });
          };
        };
      }
      throw new Error(`Unsupported tag: ${tag}`);
    },
  },
);

export default tw;
